import { useState, useEffect } from 'react';
import { C, t } from '../constants/dashboardConstants';

function Toggle({ on, onToggle }) {
  return (
    <div
      onClick={onToggle}
      style={{
        width: '57.39px', height: '30px', borderRadius: '15px',
        background: on
          ? 'linear-gradient(90deg, #FFD92B 0%, #FFA40D 100%)'
          : '#A9A9B2',
        cursor: 'pointer', position: 'relative', flexShrink: 0,
        transition: 'background 0.2s',
      }}
    >
      <div style={{
        position: 'absolute', top: '3.5px',
        left: on ? 'calc(100% - 26.5px)' : '3.5px',
        width: '23px', height: '23px', borderRadius: '50%',
        background: C.white,
        transition: 'left 0.2s',
        boxShadow: '0 1px 3px rgba(0,0,0,0.2)',
      }} />
    </div>
  );
}

function ToggleCard({ title, subtitle, on, onToggle }) {
  return (
    <div style={{
      background: on ? C.white : C.bg,
      border: `1px solid ${C.g200}`,
      borderRadius: '16px', padding: '24px',
      boxShadow: on
        ? '2px 2px 12px rgba(0,0,0,0.10)'
        : 'inset 0 2px 6px rgba(0,0,0,0.06)',
      display: 'flex', flexDirection: 'column',
      minHeight: '160px',
    }}>
      <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '24px' }}>
        <Toggle on={on} onToggle={onToggle} />
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', marginTop: 'auto' }}>
        <span style={t('18px', 600, C.bk)}>{title}</span>
        <span style={t('14px', 400, C.sub)}>{subtitle}</span>
      </div>
    </div>
  );
}

export default function PrivacySettings({ profile, onVisibilityChange, onChange }) {
  const [isPublic, setIsPublic] = useState(true);
  const [searchable, setSearchable] = useState(false);

  useEffect(() => {
    if (profile?.visibility) {
      setIsPublic(profile.visibility === 'PUBLIC');
    }
  }, [profile?.visibility]);

  const handlePublicToggle = () => {
    const next = !isPublic;
    setIsPublic(next);
    onVisibilityChange?.(next ? 'PUBLIC' : 'PRIVATE');
  };

  const handleSearchToggle = () => {
    const next = !searchable;
    setSearchable(next);
    onChange?.({ searchable: next });
  };

  return (
    <div style={{
      background: C.white, border: `1px solid ${C.g200}`,
      borderRadius: '20px', padding: '30px',
      display: 'flex', flexDirection: 'column', gap: '30px',
    }}>
      {/* 프로필 설정 */}
      <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
        <span style={t('18px', 600, C.bk)}>프로필 설정</span>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
          <ToggleCard
            title="프로필 공개"
            subtitle="모든 사용자에게 내 프로필을 공개합니다."
            on={isPublic}
            onToggle={handlePublicToggle}
          />
          <ToggleCard
            title="검색 결과 표시"
            subtitle="배우 검색 결과에 내 프로필을 표시합니다."
            on={searchable}
            onToggle={handleSearchToggle}
          />
        </div>
      </div>

      {/* 데이터 관리 */}
      <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
        <span style={t('18px', 600, C.bk)}>데이터 관리</span>
        <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
          <button style={{
            flex: 1, height: '50px',
            background: C.g200, border: 'none',
            borderRadius: '10px', cursor: 'pointer',
            display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px',
          }}>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
              <path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4" stroke={C.bk} strokeWidth="1.8" strokeLinecap="round"/>
              <polyline points="7 10 12 15 17 10" stroke={C.bk} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
              <line x1="12" y1="15" x2="12" y2="3" stroke={C.bk} strokeWidth="1.8" strokeLinecap="round"/>
            </svg>
            <span style={t('16px', 500, C.bk)}>내 데이터 다운로드</span>
          </button>

          <button style={{
            flex: 1, height: '50px',
            background: 'transparent', border: `1px solid ${C.g200}`,
            borderRadius: '10px', cursor: 'pointer',
            display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px',
          }}>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
              <path d="M3 6h18M19 6l-1 14H6L5 6M10 11v6M14 11v6M9 6V4h6v2" stroke="#E94934" strokeWidth="1.5" strokeLinecap="round"/>
            </svg>
            <span style={t('16px', 500, '#E94934')}>계정 삭제</span>
          </button>
        </div>
      </div>
    </div>
  );
}
